<template>
  <div class="notifications-content" :class="{'notifications-content--in-modal': inModal}">
    <div class="notifications-content__wrapper">
      <div class="notifications-content__body">
        <div class="notifications-content__mobile-head">
          <div>{{ $t('notifications') }}</div>
          <PopoverMenu icon="more" class="notifications-content__more">
            <div class="notifications-content__mobile-actions">
              <div class="notifications-content__action" @click="handleAllRead">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.6667 6.33337L7.33332 9.66671L5.66666 8.00004" stroke="#CCD7E6" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="8" cy="8" r="7" stroke="#CCD7E6" stroke-width="2" />
                </svg>
                <div>{{ $t('Notifications.mark-read') }}</div>
              </div>
              <div v-if="false" class="notifications-content__action" @click="openModal('notify-turn-off-confirm')">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.00009 6.00001C3.00009 3.23858 5.23867 1 8.00009 1C10.7615 1 13.0001 3.23858 13.0001 6V11.8986H3.00009V6.00001Z"
                    stroke="#CCD7E6" stroke-width="2" />
                  <path d="M5.75009 15.1749H10.2501" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
                  <path d="M2.00009 2L14.3138 13.3137" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
                </svg>
                <div>{{ $t('Notifications.turn-off') }}</div>
              </div>
              <div class="notifications-content__action notifications-content__action--red" @click="openModal('modal-confirm-delete')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 5H15" stroke="#C34343" stroke-width="2" stroke-linecap="round" />
                  <path d="M3 5V12C3 13.6569 4.34315 15 6 15H10C11.6569 15 13 13.6569 13 12V5" stroke="#C34343"
                        stroke-width="2" />
                  <path d="M5 2H11" stroke="#C34343" stroke-width="2" stroke-linecap="round" />
                </svg>
                <div>{{ $t('Notifications.delete-all') }}</div>
              </div>
            </div>
          </PopoverMenu>
          <svg class="notifications-content__mobile-close" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
            <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
          </svg>

        </div>
        <div class="notifications-content__list">
          <div v-for="group in notificationsGroupped" :key="group.date" class="group">
            <div class="group__date">
              <span class="group__date__day">{{ group.date }}</span>
              <span class="group__date__weekday">{{ group.week }}</span>
            </div>
            <NotificationsList :list="group.list" :large="true" :in-modal="inModal"/>
          </div>
        </div>
        <div class="notifications-content__side">
          <div class="notifications-content__block">
            <div class="notifications-content__label">{{ $t('Notifications.sortBy') }}</div>
            <NewCheckbox
              v-for="option in selectOptions"
              :key="option.id"
              :label="option.label"
              :value="option.id"
              :model-value="sort === option.id"
              @change="setSort(option.id)"
              round
            />
          </div>
          <div class="notifications-content__actions">
            <div class="notifications-content__label">{{ $t('settings') }}</div>
            <div class="notifications-content__action" @click="handleAllRead">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6667 6.33337L7.33332 9.66671L5.66666 8.00004" stroke="#CCD7E6" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="8" cy="8" r="7" stroke="#CCD7E6" stroke-width="2" />
              </svg>
              <div>{{ $t('Notifications.mark-read') }}</div>
            </div>
            <div v-if="false" class="notifications-content__action" @click="openModal('notify-turn-off-confirm')">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.00009 6.00001C3.00009 3.23858 5.23867 1 8.00009 1C10.7615 1 13.0001 3.23858 13.0001 6V11.8986H3.00009V6.00001Z"
                  stroke="#CCD7E6" stroke-width="2" />
                <path d="M5.75009 15.1749H10.2501" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
                <path d="M2.00009 2L14.3138 13.3137" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" />
              </svg>
              <div>{{ $t('Notifications.turn-off') }}</div>
            </div>
            <div class="notifications-content__action notifications-content__action--red" @click="openModal('modal-confirm-delete')">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5H15" stroke="#C34343" stroke-width="2" stroke-linecap="round" />
                <path d="M3 5V12C3 13.6569 4.34315 15 6 15H10C11.6569 15 13 13.6569 13 12V5" stroke="#C34343"
                      stroke-width="2" />
                <path d="M5 2H11" stroke="#C34343" stroke-width="2" stroke-linecap="round" />
              </svg>
              <div>{{ $t('Notifications.delete-all') }}</div>
            </div>
          </div>
          <!--        <SelectCustom-->
          <!--          v-model="sort"-->
          <!--          class="notifications-mobile-filter"-->
          <!--          label-by="label"-->
          <!--          display-selected-->
          <!--          :is-multiple="false"-->
          <!--          :list="selectOptions"-->
          <!--          :name="$t('Notifications.sortBy')"-->
          <!--          :show-count="false"-->
          <!--          @change="handleSelectChange"-->
          <!--        />-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationsList from '@/components/notifications/NotificationsList.vue'
import NewCheckbox from '@/components/NewCheckbox.vue'
import { withUi } from '@/components/ui'
import ModalTurnOff from '@/components/notifications/ModalTurnOff.vue'
import ModalConfirmDelete from '@/components/notifications/ModalConfirmDelete.vue'
import Modal from '@/components/modals/Modal.vue'
import Checkbox from '@/components/form/Checkbox.vue'
import SelectCustom from '@/components/form/SelectCustom.vue'
import moment from 'moment/moment'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'


export default {
  name: 'NotificationsContent',
  mixins: [withUi],
  components: { ModalTurnOff, ModalConfirmDelete, Modal, NewCheckbox, Checkbox, SelectCustom, NotificationsList },
  props: {
    inModal: Boolean,
  },
  data() {
    return {
      sort: null,
    }
  },
  computed: {
    notificationsGroupped() {
      if (this.notifications && !this.notifications.length) return []

      const formatMask = 'DD MMM'

      const groups =  this.notifications.reduce((tmp, notify) => {
        const d = moment(notify.created_at * 1000)
        const date = d.format(formatMask);
        if(!tmp[date]) {
          tmp[date] = {
            date,
            week: d.format('dd'),
            list: [],
          }
        }
        tmp[date].list.push(notify);
        return tmp;
      }, {});

      return Object.values(groups);
    },
    selectOptions() {
      return [
        { id: 'created_at', label: this.$t('sort-options.new') },
        { id: '-created_at', label: this.$t('sort-options.old') },
      ]
    },
    ...mapGetters('events', ['notificationNew']),
    ...mapState('events', ['logs']),
    ...mapState('notifications', ['notifications']),
  },
  methods: {
    handleAllRead() {
      this.notificationsRead().then(this.update);
    },
    update() {
      this.getNotifications({
        params: {
          sort: this.sort,
        }
      }).then(({ data }) => {
        this.setLogsIdsViewed(data.map(({ id }) => id))
      })
    },
    setSort(val) {
      this.sort = val;
      this.update();
    },
    ...mapMutations(['openModal']),
    ...mapMutations('events', ['setLogsIdsViewed']),
    ...mapActions('notifications', ['getNotifications', 'notificationsRead']),
  },
  created() {
    if (!this.notifications.length || this.notificationNew) {
      this.update()
    }
  },
  watch: {
    notificationNew(v) {
      if (v) {
        this.update()
      }
    },
  },
}
</script>

<style lang="scss">
.notifications-content {

  &__body {
    display: grid;
    grid-template-columns: 1fr 164px;
    grid-gap: 60px;

    @include mobile {
      grid-template-columns: 1fr;
    }
  }

  &__mobile-head {
    position: relative;
    display: none;
    justify-content: center;
    align-items: center;
    order: -2;
    margin-bottom: 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid #F2F2F2;

    font-size: 15px;
    font-weight: 700;
    line-height: 20px;

    .more__menu {
      width: fit-content;
    }

    .more__trigger {
      margin-left: 10px;
    }

    .svg-icon {
      width: 20px !important;
      height: 4px;
    }
  }

  &__mobile-close {
    display: none;
    position: absolute;
    top: -2px;
    right: 24px;
    cursor: pointer;
  }

  &--in-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    color: $darkGrey;

    .notifications-content__wrapper {
      position: relative;
      z-index: 2;
      flex: 1 0 auto;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      backface-visibility: hidden;
    }

    .notifications-content__body {
      position: relative;
      z-index: 2;
      overflow: hidden;
      width: 100%;
      max-width: 492px;
      height: 100vh;
      min-height: 1px;
      background: #ffffff;
      box-shadow: 0px 16px 89px rgba(180, 187, 198, 0.31);
      transition: opacity 0.25s ease-in-out;
      padding: 22px;
      display: flex;
      flex-direction: column;
      grid-gap: unset;
    }

    .notifications-content__side {
      order: -1;

      .checkbox-wrapper + .checkbox-wrapper {
        margin-top: 0;
        margin-left: 14px;
      }
    }

    .notifications-content__label {
      display: none;
    }

    .notifications-content__block {
      display: flex;
      margin-bottom: 24px;
    }

    .notifications-content__actions {
      display: none;
      margin-top: 0;
    }

    .notifications-content__mobile-head {
      display: flex;
    }

    .notifications-content__mobile-close {
      display: block;
    }
  }

  &__side {
    height: fit-content;

    @include mobile {
      order: -1;
    }

    .checkbox-wrapper + .checkbox-wrapper {
      margin-top: 16px;
    }
  }

  &__actions {
    margin-top: 54px;
  }

  &__label {
    margin-bottom: 16px;

    font-size: 12px;
    font-weight: 700;
    line-height: 17.7px;
    color: #474747;
  }

  &__action {
    display: flex;
    align-items: center;
    cursor: pointer;

    font-size: 15px;
    font-weight: 400;
    line-height: 23.63px;
    white-space: nowrap;
    svg {
      flex-shrink: 0;
    }

    > * + * {
      margin-left: 8px;
    }

    & + & {
      margin-top: 8px;
    }

    &--red {
      color: #C34343;
    }
  }
}
</style>
